import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { useEffect, useRef } from 'react';

/**
 * Admin-only route guard. Redirects non-admin users to home with a toast.
 * Only users with role === 'admin' can access the wrapped component.
 */
export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const toastShownRef = useRef(false);

  useEffect(() => {
    if (!loading && user && user.role !== 'admin' && !toastShownRef.current) {
      toastShownRef.current = true;
      toast.error('Admin access only. You do not have permission to view this page.');
    }
  }, [user, loading]);

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        data-testid="admin-route-loading"
      >
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
